import { render } from "./conversation.vue?vue&type=template&id=0e81f861"
import script from "./conversation.js?vue&type=script&lang=js"
export * from "./conversation.js?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=0e81f861&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__